import styles from './index.module.css'
import cn from 'clsx'

import React from 'react'
import FlexContent from './content'
type Props = {
  children: React.ReactNode
  // TODO: Remove 'none' in future because prop is optional. No spacing would be default.
  spacing?: 'none' | 'small' | 'medium' | 'large'
}

/**
 * @deprecated Use `Flex` from `components/ds` instead.
 * @see {@link components/ds/Flex}
 * @migration
 * - Replace `<Flex spacing="...">` with `<Flex gap="...">` from components/ds
 * - Spacing mapping (legacy → DS gap):
 *   - spacing="none" → gap="0"
 *   - spacing="small" → gap="2"
 *   - spacing="medium" → gap="4"
 *   - spacing="large" → gap="6"
 * - DS Flex supports additional props: direction, align, justify, wrap
 * - Flex.Content sub-component has no direct equivalent; use `<Box flexGrow="1">` instead
 *
 * A flexible layout component with configurable spacing between child elements
 * @param children - The child elements to arrange in the flex layout
 * @param spacing - The spacing between elements: 'none', 'small', 'medium', or 'large' (defaults to 'medium')
 * @returns A div element with flex layout and configurable spacing
 */
const Flex = ({
  children,
  spacing = 'medium',
}: Props): React.ReactElement<'div'> => (
  <div
    className={cn(styles.component, {
      [styles['spacing--none']]: spacing === 'none',
      [styles['spacing--small']]: spacing === 'small',
      [styles['spacing--medium']]: spacing === 'medium',
      [styles['spacing--large']]: spacing === 'large',
    })}
  >
    {children}
  </div>
)

Flex.Content = FlexContent
export default Flex
